import { useSelector } from "react-redux";
import CommunicationPipelinePermissionsSwitch from "../../../layout/screenSpecifics/Modules/CommunicationPipeline/CommunicationPipelinePermissionsSwitch";
import { useEffect } from "react";
import axios from "axios";
import { axiosPath } from "@/routing/helpers/router";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import * as currentPageAction from "../../../store/actions/currentPageAction";
import { AppNoInfo } from "@/layout/AppComponents";
import CommunicationPipelineModuleSidebar from "@/layout/screenSpecifics/Modules/CommunicationPipeline/CommunicationPipelineModuleSidebar";

export default function CommunicationPipelineHomeScreen() {
  const { moduleBridgeHex } = useParams();
  const moduleData = useSelector((state) => state.currentPage?.moduleData);
  const dispatch = useDispatch();

  // > LOAD MODULE DATA //
  useEffect(() => {
    axios
      .post(
        axiosPath("api_r_user_module_communicationPipeline_getModuleData"),
        { moduleBridgeHex },
      )
      .then((r) => {
        dispatch(currentPageAction.change("moduleData", r.data, true));
      });
  }, []);
  // > LOAD MODULE DATA //

  if (!moduleData) return <AppNoInfo />;

  return (
    <>
      {moduleData?.permissionLevel === 0 && (
        <CommunicationPipelineModuleSidebar />
      )}
      <CommunicationPipelinePermissionsSwitch
        permissionLevel={moduleData?.permissionLevel}
      />
    </>
  );
}
